import { action, computed, persist, thunk } from 'easy-peasy';
import type { Action, Computed, Thunk } from 'easy-peasy';

import type { StoreModel } from './model';

import type { ExamListFilterUrlSearchParams } from '~/components/shared/Dashboard/hooks/useExamListFilterState';

/**
 * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
 */
const getCourse = () => {
    try {
        const dashboardFilter = window.localStorage.getItem(
            'smartlearn.dashboardFilter',
        );
        return JSON.parse(dashboardFilter).course ?? null;
    } catch {
        return null;
    }
};

/**
 * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
 */
const getCreatedBy = () => {
    try {
        const dashboardFilter = window.localStorage.getItem(
            'smartlearn.dashboardFilter',
        );
        return JSON.parse(dashboardFilter).createdBy ?? '';
    } catch {
        return '';
    }
};

/**
 * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
 */
const getSearchName = () => {
    try {
        const dashboardFilter = window.localStorage.getItem(
            'smartlearn.dashboardFilter',
        );
        return JSON.parse(dashboardFilter).searchName ?? '';
    } catch {
        return '';
    }
};

/**
 * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
 */
const saveFilter = (item: { [key: string]: unknown }) => {
    try {
        const dashboardFilter = window.localStorage.getItem(
            'smartlearn.dashboardFilter',
        );
        const json = JSON.parse(dashboardFilter);
        window.localStorage.setItem(
            'smartlearn.dashboardFilter',
            JSON.stringify({ ...json, ...item }),
        );
    } catch {
        window.localStorage.setItem(
            'smartlearn.dashboardFilter',
            JSON.stringify(item),
        );
    }
};

type FilterCount = {
    pilotCount: number;
    variantCount: number;
    eventsCount: number;
    passesCount: number;
    favouriteCount: number;
};

export interface DashboardFilterModel {
    activeFilters: Computed<
        DashboardFilterModel,
        ExamListFilterUrlSearchParams,
        StoreModel
    >;
    saveActiveFilters: Thunk<
        DashboardFilterModel,
        | DashboardFilterModel['activeAuthorFilters']
        | DashboardFilterModel['activeStudentFilters'],
        unknown,
        StoreModel
    >;

    activeAuthorFilters: ExamListFilterUrlSearchParams;
    saveActiveAuthorFilters: Action<
        DashboardFilterModel,
        DashboardFilterModel['activeAuthorFilters']
    >;

    activeStudentFilters: ExamListFilterUrlSearchParams;
    saveActiveStudentFilters: Action<
        DashboardFilterModel,
        DashboardFilterModel['activeStudentFilters']
    >;

    /**
     * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
     */
    course: string;

    /**
     * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
     */
    createdBy: string;

    /**
     * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
     */
    searchName: string;

    /**
     * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
     */
    changeCourse: Action<DashboardFilterModel, string>;

    /**
     * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
     */
    changeCreatedBy: Action<DashboardFilterModel, string>;

    /**
     * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
     */
    changeSearchName: Action<DashboardFilterModel, string>;

    filterCount: FilterCount;

    /**
     * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
     */
    updateFilter: Action<DashboardFilterModel, FilterCount>;
}

export const dashboardFilterModel: DashboardFilterModel = persist(
    {
        activeFilters: computed(
            [(state) => state, (_, storeState) => storeState.userMode.mode],
            (state, mode) => {
                if (mode === 'author') {
                    return state.activeAuthorFilters;
                } else {
                    return state.activeStudentFilters;
                }
            },
        ),
        saveActiveFilters: thunk((actions, payload, helpers) => {
            const mode = helpers.getStoreState().userMode.mode;

            if (mode === 'author') {
                actions.saveActiveAuthorFilters(payload);
            } else {
                actions.saveActiveStudentFilters(payload);
            }
        }),
        activeAuthorFilters: {},
        saveActiveAuthorFilters: action((state, payload) => {
            state.activeAuthorFilters = payload;
        }),
        activeStudentFilters: {},
        saveActiveStudentFilters: action((state, payload) => {
            state.activeStudentFilters = payload;
        }),

        /**
         * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
         */
        course: getCourse(),

        /**
         * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
         */
        createdBy: getCreatedBy(),

        /**
         * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
         */
        searchName: getSearchName(),

        /**
         * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
         */
        changeCourse: action((state, payload) => {
            saveFilter({ course: payload });
            state.course = payload;
        }),

        /**
         * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
         */
        changeCreatedBy: action((state, payload) => {
            saveFilter({ createdBy: payload });
            state.createdBy = payload;
        }),

        /**
         * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
         */
        changeSearchName: action((state, payload) => {
            saveFilter({ searchName: payload });
            state.searchName = payload;
        }),

        filterCount: {
            pilotCount: 0,
            variantCount: 0,
            eventsCount: 0,
            passesCount: 0,
            favouriteCount: 0,
        },

        /**
         * @deprecated Marked for removal without replacement. `activeFilters` is the new API.
         */
        updateFilter: action((state, payload) => {
            state.filterCount = payload;
        }),
    },
    {
        allow: ['activeFilters', 'activeAuthorFilters', 'activeStudentFilters'],
    },
);
